import { render, staticRenderFns } from "./TrainingDataAnalysis.vue?vue&type=template&id=2ffee64f&scoped=true&"
import script from "./TrainingDataAnalysis.vue?vue&type=script&lang=js&"
export * from "./TrainingDataAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDataAnalysis.vue?vue&type=style&index=0&id=2ffee64f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffee64f",
  null
  
)

export default component.exports